import { httpRequest } from "@/store/api/actions/httpRequest.js";
import { setSiteId } from "@/store/api/actions/setSiteId.js";
import { patchEntriesBulk } from "@/store/api/actions/patchEntriesBulk.js";
import { patchSubcategoriesBulk } from "@/store/api/actions/patchSubcategoriesBulk.js";
import { patchCategoriesBulk } from "@/store/api/actions/patchCategoriesBulk.js";
import { deleteBulk } from "@/store/api/actions/deleteBulk.js";
import { patchMediaMetaData } from "@/store/api/actions/patchMediaMetaData.js";
import { addExternalMedia } from "@/store/api/actions/addExternalMedia.js";
import { patchEntityMedia } from "@/store/api/actions/patchEntityMedia.js";
import { saveSiteData } from "@/store/api/actions/saveSiteData.js";
import { saveHomeButtonData } from "@/store/api/actions/saveHomeButtonData.js";
import { addCategory } from "@/store/api/actions/addCategory.js";
import { deleteEntry } from "@/store/api/actions/deleteEntry.js";
import { patchSubCategory } from "@/store/api/actions/patchSubCategory.js";
import { addEntry } from "@/store/api/actions/addEntry.js";
import { deleteSubCategory } from "@/store/api/actions/deleteSubCategory.js";
import { fetchCategoryTree } from "@/store/api/actions/fetchCategoryTree.js";
import { fetchRecentlyDeleted } from "@/store/api/actions/fetchRecentlyDeleted.js";
import { moveEntry } from "@/store/api/actions/moveEntry.js";
import { moveCategory } from "@/store/api/actions/moveCategory.js";
import { fetchMoveDocumentDestinations } from "@/store/api/actions/fetchMoveDocumentDestinations.js";
import { addSubCategory } from "@/store/api/actions/addSubCategory.js";
import { fetchCalendar } from "@/store/api/actions/fetchCalendar.js";
import { fetchMostCommonEntryLayout } from "@/store/api/actions/fetchMostCommonEntryLayout.js";
import { patchCategory } from "@/store/api/actions/patchCategory.js";
import { bulkRecordUpload } from "@/store/api/actions/bulkRecordUpload.js";
import { fetchCategories } from "@/store/api/actions/fetchCategories.js";
import { fetchSearchOptions } from "@/store/api/actions/fetchSearchOptions.js";
import { patchEntry } from "@/store/api/actions/patchEntry.js";
import { switchCategoryType } from "@/store/api/actions/switchCategoryType.js";
import { deleteCategory } from "@/store/api/actions/deleteCategory.js";
import { fetchCategory } from "@/store/api/actions/fetchCategory.js";
import { patchSite } from "@/store/api/actions/patchSite.js";
import { updateEntries } from "@/store/api/actions/updateEntries.js";
import { patchCategories } from "@/store/api/actions/patchCategories.js";
import { fetchStylingData } from "@/store/api/actions/fetchStylingData.js";
import { addUser } from "@/store/api/actions/addUser.js";
import { deleteUser } from "@/store/api/actions/deleteUser.js";
import { patchUser } from "@/store/api/actions/patchUser.js";
import { fetchUsers } from "@/store/api/actions/fetchUsers.js";
import { copyCategoryStructure } from "@/store/api/actions/copyCategoryStructure.js";
import { fetchAllCategories } from "@/store/api/actions/fetchAllCategories.js";
import { fetchUser } from "@/store/api/actions/fetchUser.js";
import { signAgreements } from "@/store/api/actions/signAgreements.js";
import { restoreDocument } from "@/store/api/actions/restoreDocument.js";
import { patchEntryRecord } from "@/store/api/actions/patchEntryRecord.js";
import { fetchAnalytics } from "@/store/api/actions/fetchAnalytics.js";
import { fetchDatadogAnalytics } from "@/store/api/actions/fetchDatadogAnalytics.js";
import { fetchTweets } from "@/store/api/actions/fetchTweets.js";
import { confirmHomeButtonData } from "@/store/api/actions/confirmHomeButtonData.js";
import { addEntriesBulk } from "@/store/api/actions/addEntriesBulk.js";
import { copyEntry } from "@/store/api/actions/copyEntry.js";
import { fetchAllCastScreens } from "@/store/api/actions/fetchAllCastScreens.js";
import { fetchSiteSwitcherSites } from "@/store/api/actions/fetchSiteSwitcherSites.js";
import { searchSiteSwitcherSites } from "@/store/api/actions/searchSiteSwitcherSites.js";

export default {
  httpRequest,
  // Public endpoints
  fetchCategory,
  fetchCategories,
  fetchCategoryTree,
  fetchSearchOptions,
  fetchMoveDocumentDestinations,
  fetchStylingData,
  fetchCalendar,
  fetchAllCategories,
  fetchTweets,
  // Auth endpoints
  addCategory,
  deleteEntry,
  patchSubCategory,
  addEntry,
  deleteSubCategory,
  moveEntry,
  moveCategory,
  addSubCategory,
  fetchMostCommonEntryLayout,
  patchCategory,
  bulkRecordUpload,
  patchEntry,
  switchCategoryType,
  deleteCategory,
  patchSite,
  updateEntries,
  patchCategories,
  addUser,
  deleteUser,
  patchUser,
  fetchUsers,
  copyCategoryStructure,
  fetchUser,
  signAgreements,
  setSiteId,
  fetchRecentlyDeleted,
  restoreDocument,
  patchEntriesBulk,
  patchSubcategoriesBulk,
  patchCategoriesBulk,
  deleteBulk,
  patchMediaMetaData,
  addExternalMedia,
  patchEntityMedia,
  saveSiteData,
  saveHomeButtonData,
  patchEntryRecord,
  fetchAnalytics,
  confirmHomeButtonData,
  addEntriesBulk,
  copyEntry,
  fetchAllCastScreens,
  fetchSiteSwitcherSites,
  searchSiteSwitcherSites,
  fetchDatadogAnalytics,
};
